export const environment = {
    production: true,
    version: '5.2.0',
    stage: 'production',
    identifier: 'production',
    timestamp: '2026-11-03T20:23:02.919Z',
    SHARE_BASE_URL: 'https://share.vuframe.com/',
    API_BASE_URL: window.location.origin + '/api/vf/',
    CDN_BASE_URL: window.location.origin + '/api/vf/cdn/',
    CLOUDFRONT_CDN: true,
    BUGSNAG_API_KEY: 'YTlmZDYwM2Y0MjUyZjM5NGIzNmRmMDQ4YzFjOGQ1YTQ=',
    vercelAnalytics: false
  };
  